var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"recordBtn",staticClass:"record-btn"},[_c('span',{on:{"click":_vm.clickHandler}},[_c('el-image',{staticStyle:{"height":"20px","position":"relative","top":"4px"},attrs:{"src":_vm.iconRecord}}),_vm._v("录音")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }